import React from "react";

function Betting() {
  const penalties = [
    { id: 1, action: "Smoking/Drinking in the property", penalty: "500" },
    {
      id: 2,
      action: "Bringing visitors of opposite gender to the room",
      penalty: "1000",
    },

    {
      id: 3,
      action: "Obstructing or changing view of CCTV cameras",
      penalty: "2000",
    },
    {
      id: 4,
      action: "Taking food and utensils to the room without permission",
      penalty: "500",
    },
    {
      id: 5,
      action: "Lost Key replacement",
      penalty: "500",
    },
    {
      id: 6,
      action: "Leaving Lights/Water taps open in absence",
      penalty: "500",
    },
    {
      id: 7,
      action:
        "Using non-mandated electrical appliances in rooms other than rooms having prepaid electrical meters.",
      penalty: "1000",
    },
  ];
  return (
    <>
      <div>
        <div className="flex flex-col  items-start sm:px-16 p-6">
          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Intoxication, Betting and Gambling
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Yostel is strictly opposed to possession, distribution and
              consumption of illegal substances inside the House. If any
              instance of such action is brought to the notice of Yostel
              Representatives, Yostel has the right to terminate the Resident
              Agreement and inform the parents/college authorities, accordingly.
            </li>
            <li>
              Betting and Gambling by any means is strictly prohibited in the
              House. In the case of any such instance, Yostel has the right to
              immediately terminate the Resident Agreement and inform the
              parents/college authorities.
            </li>
            <li>Conduct & Behaviour</li>
            <li>
              Ragging in any form whatsoever is strictly prohibited and is a
              cognizable offence under the Indian Penal Code, 1860. All
              instances of ragging brought to the notice of Yostel
              Representatives will be reported to the appropriate legal
              authorities.
            </li>
            <li>
              In case of any emergency or crisis, the residents must follow the
              guidelines of the Yostel Representatives / Security Officer /
              Nodal Officer strictly.
            </li>
            <li>
              Any resident or a group of residents, who wish to organize a party
              and/or invite guests, must take prior permission of the Yostel
              Representative and it will be the responsibility of the residents
              to ensure the decorum of the House is maintained at all times and
              that the premises are cleaned up after the party.
            </li>
            <li>
              Yostel treats all its employees and service providers including
              housekeeping, security and food vendors with dignity and respect.
              It is expected that the residents also uphold this principle in
              their dealings with all Yostel employees, representatives and
              service providers.
            </li>
            <li>
              The residents must always behave in accordance with the Yostel
              Anti-Harassment Policy and shall not harass any persons. Further,
              all residents must respect the personal beliefs of the other
              residents, such that no resident hurts any religious sentiments,
              beliefs, or practices in any way whatsoever.
            </li>
            <li>
              Making loud noises, including playing loud music between 10.30 PM
              to 6.00 AM is strictly prohibited. These timings may differ for
              certain Yostel houses/neighbourhoods and will be communicated via
              the House noticeboards.{" "}
            </li>
            <li>
              The residents should not behave in any manner which is deemed to
              be offensive by the neighbours or by the society either in the
              premises or in the neighbouring areas surrounding the premises.{" "}
            </li>
            <li>
              The resident shall cooperate with the Yostel Representative for
              getting his/her police verification, FRRO compliance and any other
              compliance, as required by Yostel, done timely.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Pantry Rules
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Cooking of food in any area except the pantry room is strictly
              prohibited.
            </li>
            <li>
              Personal food items can be stored in common refrigerators. The
              residents should adequately label their food items. Yostel will
              not be liable for consumption of personal food items by the other
              residents.
            </li>
            <li>
              The residents should ensure that the pantry area is clean after
              their use. All the dirty dishes should be placed in the sink, and
              any leftover and/or garbage must be thrown in the appropriate
              dustbins. The residents will be liable for damage to common
              utensils.
            </li>
            <li>
              If food is ordered from outside by the residents, then all
              leftovers and packaging materials should be disposed of in
              appropriate dustbins.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Food & Beverage Services
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              All residents are encouraged to consume all food items only in the
              designated cafeteria area. However, when a resident wishes to
              carry their food to the room, they must strictly use their
              personal utensils. Taking the common cutlery and utensils provided
              by Yostel to the room (including plates, spoons, bowls and
              glasses) is strictly prohibited.
            </li>
            <li>
              In case a resident decides to take the food to their room, they
              are expected to act responsibly and avoid food wastage. It is also
              their responsibility to ensure that any leftovers are disposed of
              in appropriate dustbins. Furthermore, immediate consumption of
              food is highly advised, as a delay may impact the quality of food.
            </li>
            <li>
              Cooking or reheating of food inside the room is strictly
              prohibited under all circumstances.
            </li>
            <li>
              For every meal, the resident is required to punch their attendance
              through the QR code scan feature on the Yostel Resident app or in
              any other way communicated by Yostel to mark the food attendance
              before taking the food.
            </li>
            <li>
              Select dishes will be served in limited grammages or quantities.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Water & Electricity Consumption
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Water should be used judiciously. The residents should report any
              water leakages to the Yostel Representatives as soon as the same
              is noticed.
            </li>
            <li>
              Electricity billing will be determined by either (a) prepaid
              electricity meters (room-level), where installed, or (b) actual
              units consumed as recorded by the main electricity meter for the
              House.
            </li>
            <li>
              Prepaid Electricity Meters (room-level): Wherever prepaid
              electricity meters are in place for the entire room, residents are
              responsible for recharging them as per planned electricity usage.
              These charges remain applicable to the room, regardless of the
              number of occupants. Any disagreements among roommates regarding
              billing or electricity cost division should be resolved privately,
              as Yostel will not intervene in such matters.
            </li>
            <li>
              Main Electricity Meter: In cases where prepaid meters are not
              installed or installed only for in-room ACs, then charges will be
              calculated based on total units consumed, as measured by the main
              electricity meter(s) for the House. Even if a resident is absent
              for part of the month, electricity charges will be billed equally
              among all residents. In cases where prepaid meters for the ACs
              have been installed in the room, the in-room AC consumption will
              be adjusted against the final electricity charges.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Security & Safety
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              All residents of a House can enter/exit the House by accessing the
              smart locks installed on the main entrance door through their
              respective access control device/Yostel Resident App/ID Card, as
              applicable
            </li>
            <li>
              Being responsible adults, all residents of a House are free to
              enter or exit their House at any time without restrictions,
              except:
            </li>
            <li>Residents below the age of 18 years</li>
            <li>
              First-year student residents who have not yet completed first 3
              months of their in-campus course duration
            </li>
            <li>
              The residents, who are yet to complete the first 3 months of their
              Year 1 in college &/or are less than 18 years of age, are required
              to obtain approval for any late entry, exit, night-out or leaves.
              All such request applications need to be made only through the
              Yostel Resident App. Any such request will have to be approved by
              the respective parent/guardian and notified to the Yostel Security
              team.
            </li>
            <li>
              In special circumstances, the Yostel Security team reserves the
              right to reject any late entry, exit or night-out from any of its
              House at its sole discretion.
            </li>
            <li>
              Yostel has the right to share the entry-exit or leave data with
              the parents and authorities, if required under law.
            </li>
            <li>
              Yostel will not be responsible for the loss of any personal
              belongings of the residents. The residents are strongly advised to
              keep secure and lock all their valuables e.g. mobile phones,
              laptop, watches, money etc. at all times. While leaving the room
              or going on leave, it is the responsibility of the resident to
              ensure all their belongings are securely stored and locked in
              their cupboards. Yostel would not entertain any claims for the
              loss/damage of any loose or unsecured belongings of the resident.
            </li>
            <li>
              Building repairs and maintenance is a continuous and planned
              affair and Yostel reserves the right to open and enter any room
              while the student is on leave to carry out such maintenance work.
              The same would be carried out in presence of the Security / Yostel
              representatives.
            </li>
            <li>
              Possession, distribution and use of firearms, lethal weapons
              (including air guns), illegal substances and hazardous material
              are strictly prohibited in the residences. We reserve the right to
              search bags of the residents as well as their visitors at any time
              and confiscate any prohibited substances that may be found in
              their luggage or in their possession.
            </li>
            <li>
              In case of any emergency, please contact the Yostel security team
              or the Yostel helpline. Important contact numbers will be provided
              to all residents at the time of move-in.
            </li>
            <li>
              Tampering with any security or fire-fighting equipment is strictly
              prohibited. The resident responsible for such actions will be held
              responsible for the cost of restoring the damaged equipment.
            </li>
            <li>
              In case of any emergencies in the building, all the residents
              should be patient and cooperate with the Yostel Representatives.
            </li>
            <li>
              Yostel reserves its right to handover its property to the
              Government Authorities in case there is any
              notice/order/directions from the District Administration or State
              Government to acquire its property during an emergency. The rooms
              occupied by the residents may be vacated and their belongings may
              be shifted in their absence for any necessary compliance of such
              Government Order.
            </li>
            <li>
              Yostel reserves the right to update or revise the safety and
              security House Rules at any time at its sole discretion.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Housekeeping
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Regular housekeeping is an important aspect to ensure cleanliness
              and hygiene is always maintained in the House. To ensure the same,
              cleaning of the room may be carried out in the absence of
              residents as well, so the residents are advised not to leave their
              valuables open and unsecured in their room. The residents must
              ensure their valuables are always safely placed in storage and the
              rooms are always kept locked.
            </li>
            <li>
              Please note, the services of the housekeeping staff can’t be
              utilized for any personal work. For example: no personal utensils
              will be washed by the housekeeping staff.
            </li>
            <li>
              The residents are expected to cooperate in the periodic
              (quarterly) pest control / fumigation / preventive maintenance
              activity.
            </li>
            <li>
              Littering the room and common spaces is strictly prohibited.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Laundry
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Laundry services are meant for regular daily wear only. For
              hygiene considerations, no underclothing or socks will be accepted
              for Laundry.
            </li>
            <li>
              The following items should not be given in general laundry
              service, as they can get damaged:
            </li>
            <li>Any delicate or expensive branded clothing</li>
            <li>Woollens, jackets, leather items, embroidered clothing</li>
            <li>Items strictly meant for dry cleaning</li>
            <li>
              It is the resident’s responsibility to ensure that the correct
              information is provided about the number of pieces of clothing
              being given for the laundry service.
            </li>
            <li>
              Any discrepancy or damages in laundered garments need to be
              informed to Yostel within 6 hours of receiving the clothing.
            </li>
            <li>
              As per industry standards, 100% stain-removal is not possible for
              certain types of stains. For e.g. if there is an Oil / Ink / Food
              stain on clothing, it will get reduced by up to 60% depending on
              the type of stain.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Internet
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Bandwidth speed will depend on the service provider and the House
              location. Speed will be limited per user and may be changed as per
              company policy.
            </li>
            <li>
              Devices per user: Houses may have a restriction on the maximum
              number of devices per user. One user can access the internet on
              limited devices at a time (limit of devices may vary House to
              House).
            </li>
            <li>
              Yostel is committed to offer a fair internet experience to
              everyone for which Yostel may continuously monitor internet usage
              by the residents. A Fair Use Policy i.e.to ensures that every
              resident uses data in moderation with respect to the fellow
              residents (given in Gigabytes (GB) of data) will apply on all
              internet services.
            </li>
            <li>Browsing access: The residents are not allowed to -</li>
            <li>Access pornography</li>
            <li>Create and maintain fake accounts</li>
            <li>Download and view pirated content</li>
            <li>Faking IP</li>
            <li>Piggybacking: Using someone else’s credentials</li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Usage of Electrical Appliances
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              Usage of appliances like heaters, coils, iron boxes or any other
              heating/cooking electrical gadget is strictly prohibited inside
              the room unless the room has prepaid electricity meters.
            </li>
            <li>
              Residents found cooking inside a room using electric cookers,
              coffee makers, roti makers, heaters or any combustible material,
              will be considered a serious violation leading to a penalty.
            </li>
            <li>
              While leaving the room premises, residents must ensure that they
              switch off all lights, fans, electrical appliances including ACs,
              heaters, geysers, mosquito-repellent machines etc.
            </li>
            <li>
              In case of power being run on DG back-up, usage of electrical
              items especially ACs, geysers, washing machines, elevators etc.
              will be restricted. Management can also take the liberty of
              revoking the electricity access of these temporarily to conserve
              power backup.
            </li>
            <li>
              The right containers /bowls should be placed inside a microwave to
              avoid a hazardous situation. In case of doubt, please connect with
              the Yostel Representatives for assistance.
            </li>
            <li>
              Residents should refrain from overloading the washing machines,
              ensuring that clothes are unloaded immediately after usage. In
              case clothes are found lying unclaimed, Yostel staff will not be
              held responsible if misplaced.
            </li>
            <li>
              Residents should avoid stocking up the fridge unnecessarily. The
              housekeeping staff reserve the right to get rid of any leftovers
              found in the refrigerato
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Health
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              The residents shall intimate Yostel Representatives immediately if
              any critical or transferable illness is detected to prevent other
              residents from getting infected.
            </li>
            <li>
              The common areas in Houses are under CCTV surveillance for safety
              and security of the residents. The residents are advised to
              maintain decorum in common areas and not to obstruct / change the
              view of CCTV by any means.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Police Complaints
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              The residents shall inform the Residence Captain / Yostel
              Representative before calling Police Emergency Numbers i.e. '100'
              in case of any emergency.{" "}
            </li>
            <li>
              The residents shall immediately inform the Yostel Representative
              for any engagements or encounters with Police.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Visitors & Guests
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              All visitors must register at the reception area of the House and
              provide all details and documents as requested by the Yostel
              Security team before entering any residence.
            </li>
            <li>
              In specific male/female properties, visitors only from the same
              gender may enter the resident’s room with the consent of the
              resident’s roommate. If the roommate(s) has any objection or if
              the visitor is of the opposite gender, the visitor will only be
              allowed till the reception/common area. However, in co-ed
              residences, visitors of the opposite gender may be allowed to
              enter the room.
            </li>
            <li>
              Residents are allowed to invite guests of the same gender for
              overnight stay on the premises by requesting a guest booking in
              advance on a paid basis. The permission for the same is subject to
              availability and the consent of the existing roommate(s). The
              guest can access Wi-Fi, food and common area amenities during
              their stay at the property. Charges for the stay and other
              expenses will be invoiced to the resident. For details regarding
              the duration of stay, amenities provided, associated charges,
              etc., the Residence Captain can be contacted
            </li>
            <li>
              Parents of the residents will be allowed to access the room in the
              presence of the resident during the day subject to the roommate(s)
              consent. For overnight stays, mothers will be allowed to stay with
              their wards, while the fathers will only be allowed in male-only
              Houses. The Residence Captain can be contacted for details
              regarding the duration of stay, amenities provided, associated
              charges, etc.
            </li>
            <li>
              The Yostel Representatives will not entertain visitors of the
              residents in the event the resident is absent.
            </li>
            <li>
              The resident will be wholly responsible and financially liable for
              all actions of the resident's visitor and guests.
            </li>
            <li>
              The local residence management reserves the right to place
              restrictions on the access of visitors in the event that utility
              consumption increases dramatically, a visitor’s behaviour is
              inappropriate or hampers the decorum, or the people-carrying
              capacity of the building is compromised in any way.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Rent and Payments
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              The resident shall pay all fees and charges timely and, in the
              manner, prescribed as per their Resident Agreement.
            </li>
            <li>
              Any disputes related to rent should be flagged to the customer
              experience team, as per the process laid out, and such requests
              will be actioned upon the timelines mentioned by Yostel. However,
              any pending disputes in rent should not be a reason for not making
              timely payments.
            </li>
            <li>
              In case of continuous default of payments, Yostel reserves the
              right for immediate termination of Agreement and evicting the
              defaulter resident.
            </li>
            <li>
              The residents may not be allowed to go on leaves or refuse to
              leave the premises with their belongings in case of pending rental
              payments until the same gets resolved and all the dues are
              cleared.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Complaints and Suggestions
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              The Yostel customer experience team will conduct feedback sessions
              on a regular basis. All the residents are asked to participate in
              the sessions actively so as to ensure the best delivery of
              services. From our perspective, any complaints, suggestions or
              enquiries are always welcome.
            </li>
            <li>
              The residents are required to share feedback/submit queries/raise
              complaints on the Resident App under the 'Complaints and
              Suggestions section'.
            </li>
            <li>
              The residents should only submit genuine complaints in the
              ‘Complaints and Suggestions section' in Resident App.
            </li>
            <li>
              Defaming (Oral or written communication of a false statement about
              another that unjustly harms their reputation and usually
              constitutes a tort or crime) any person including fellow Stanzens
              and Yostel staff or influencing fellow Stanzens for defaming any
              person or Yostel by any means (i.e. directly, indirectly or on
              social media) is strictly prohibited. This may attract serious
              consequences including termination of the agreement and legal
              action.
            </li>
          </ol>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            Penalties & Fines
          </h1>
          <div className="overflow-x-auto w-full my-4">
            <table className="min-w-full border border-gray-300 rounded-lg">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 border-b">Sl No.</th>
                  <th className="px-4 py-2 border-b">Actions</th>
                  <th className="px-4 py-2 border-b">
                    Penalty per instance(Rs)
                  </th>
                </tr>
              </thead>
              <tbody>
                {penalties.map((item, index) => (
                  <tr key={item.id} className="text-center hover:bg-gray-50">
                    <td className="px-4 py-2 border-b">{index + 1}</td>
                    <td className="px-4 py-2 border-b">{item.action}</td>
                    <td className="px-4 py-2 border-b">{item.penalty}/-</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
            General
          </h1>
          <ol className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4 pb-10 px-6">
            <li>
              No animals or pets will be brought inside the House by any person.
            </li>
            <li>
              Yostel residences are apolitical and areligious. No political or
              religious gatherings will be permitted at the residence without
              the consent of the Yostel local residence management.
            </li>
            <li>
              Yostel and the Yostel Representatives reserve the right to make
              spot checks on the Houses and rooms without having to give prior
              notice to the residents.
            </li>
            <li>
              Yostel will not be responsible for any packages / parcels received
              at the House. Stanzens are requested to coordinate & collect their
              parcels as soon as it reaches the Houses from the delivery boy.
            </li>
            <li>
              Electricians, contractors or any other service person may enter
              rooms as and when necessary, in the course of their duty under the
              supervision of the Yostel Representatives. The Yostel
              Representative shall ensure that all such activity is done in a
              manner which respects the privacy and dignity of the residents.
            </li>
            <li>
              The Yostel Representatives reserve the right to move residents to
              other rooms if there is a necessity or emergency.
            </li>
            <li>
              The Yostel team reserves the right to revise the rules and
              regulations from time to time and will keep the residents informed
              of any changes in the form of notices. Ignorance of any such
              amendments to the rules will not be accepted as an excuse for any
              breach of rules and regulations.
            </li>
            <li>
              Yostel provides a set of consumables for the entertainment/ games
              area including remote batteries, accessories for games/sports like
              darts, dice, cue sticks, rackets etc. The same shall be maintained
              by the residents in good condition. Any loss or damage to the said
              consumables shall be borne by the resident responsible for such
              loss or damage.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}

export default Betting;
